import { call, put, takeLatest } from "redux-saga/effects";
import { MLPUBLICAPI } from "apiPublic";
import ValidationResponse from "contracts/responses/ValidationResponse";
import PaansCheckResponse from "contracts/responses/PaansCheckResponse";
import SendPassCodeResponse from "contracts/responses/SendPassCodeResponse";
import MagicActionResponse from "contracts/responses/MagicActionResponse";
import Enum from "contracts/responses/Enum";
import AUTHORIZE_STATUS from "AuthorizeLink/constants/status";
import { history } from "../helpers";
import {
  AUTHORIZE_LINK_VALIDATE_REQUEST,
  AUTHORIZE_LINK_VALIDATE_SUCCESSFUL,
  AUTHORIZE_LINK_VALIDATE_ERROR,
  AUTHORIZE_PASSCODE_VALIDATE_REQUEST,
  AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL,
  AUTHORIZE_PASSCODE_VALIDATE_ERROR,
  AUTHORIZE_PAANS_CHECK_REQUEST,
  AUTHORIZE_PAANS_CHECK_SUCCESSFUL,
  AUTHORIZE_PAANS_CHECK_ERROR,
  AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST,
  AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL,
  AUTHORIZE_PASSCODE_ACTION_DATA_ERROR,
  AUTHORIZE_LINK_ACTION_DATA_REQUEST,
  AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL,
  AUTHORIZE_LINK_ACTION_DATA_ERROR,
  AUTHORIZE_LINK_ACTION_DETAIL_REQUEST,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_SUCCESSFUL,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_ERROR,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE,
  AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL,
  AUTHORIZE_LINK_ACTION_DETAIL_ERROR,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR,
  AUTHORIZE_LINK_UPDATE_STATUS,
  AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST,
  AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST,
  AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL,
  AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR,
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR
} from "./constants/actionTypes";

const apiPublic = new MLPUBLICAPI();

export function* validateLink(action) {
  const { response, error } = yield call(
    apiPublic.action.validateAction,
    action.payload
  );
  if (response)
    yield put({
      type: AUTHORIZE_LINK_VALIDATE_SUCCESSFUL,
      payload: new ValidationResponse(response.data)
    });
  else if (error.message === 'Request failed with status code 403')
    yield put({
      type: AUTHORIZE_LINK_VALIDATE_SUCCESSFUL,
      payload: new ValidationResponse()
    });
  else yield put({ type: AUTHORIZE_LINK_VALIDATE_ERROR, payload: error });
}
export function* validatePassCode(action) {
  let { response, error } = yield call(
    apiPublic.action.validatePassCode,
    action.payload
  );

  if (response) {
    yield put({
      type: AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL,
      payload: response.data
    });
  } else yield put({ type: AUTHORIZE_PASSCODE_VALIDATE_ERROR, payload: error });
}

export function* validatePaans(action) {
   let { response, error } = yield call(
     apiPublic.action.validatePaans,
     action.payload
   );

  if (response) {
    yield put({
      type: AUTHORIZE_PAANS_CHECK_SUCCESSFUL,
      payload: new PaansCheckResponse(response.data)
    });
  } else yield put({ type: AUTHORIZE_PAANS_CHECK_ERROR, payload: error });
}

export function* getActionData(action) {
  const { response, error } = yield call(
    apiPublic.action.getActionData,
    action.payload
  );
  if (response) {
    yield put({
      type: AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL,
      payload: new MagicActionResponse(response.data.data)
    });
    yield put({
      type: AUTHORIZE_LINK_UPDATE_STATUS,
      payload: AUTHORIZE_STATUS.AUTHORIZE
    });
  } else {
    yield put({
      type: AUTHORIZE_LINK_ACTION_DATA_ERROR,
      payload: error
    });
  }
}
export function* expireOnTime(action) {
  const { response, error } = yield call(
    apiPublic.action.expireOnTime,
    action.payload
  );
}
export function* sendPassCode(action) {
  const { response, error } = yield call(
    apiPublic.action.sendPassCode,
    action.payload
  );
  if (response) {
    yield put({
      type: AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL,
      payload: new SendPassCodeResponse(response.data)
    });
  } else
    yield put({ type: AUTHORIZE_PASSCODE_ACTION_DATA_ERROR, payload: error });
}
export function* getActionDetails(action) {
  const { response, error } = yield call(
    apiPublic.action.getActionDetails,
    action.payload
  );
  if (response)
    yield put({
      type: AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL,
      payload: response.data.data
    });
  else yield put({ type: AUTHORIZE_LINK_ACTION_DETAIL_ERROR, payload: error });
}
export function* getEnumActionTypes(action) {
  const { response, error } = yield call(apiPublic.enum.getActionTypes);
  if (response)
    yield put({
      type: AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL,
      payload: _.map(response.data.data, function(n) {
        return new Enum(n);
      })
    });
  else
    yield put({ type: AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR, payload: error });
}
export function* getEnumActionValidations(action) {
  const { response, error } = yield call(apiPublic.enum.getActionValidations);
  if (response)
    yield put({
      type: AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL,
      payload: _.map(response.data.data, function(n) {
        return new Enum(n);
      })
    });
  else
    yield put({
      type: AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR,
      payload: error
    });
}

export function* isConfirmationCompleted(action) {
  const { response, error } = yield call(
    apiPublic.action.isConfirmationCompleted,
    action.payload
  );
  if (response) {
    yield put({
      type: AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL,
      payload: response.data.data.isConfirmationCompleted
    });
  } else
    yield put({
      type: AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR,
      payload: error
    });
}

export function* checkActiveRequest(action) {
  const { response } = yield call(
    apiPublic.action.isRequestActive,
    action.payload
  );
  if (response) {
    if (response.data) {
      if (response.data.data) {
        const isProjectActive =
          response.data.data.isActive == undefined
            ? true
            : response.data.data.isActive;
        const isRequestActive =
          response.data.data.isRequestActive == undefined
            ? true
            : response.data.data.isRequestActive;

        if (!isProjectActive || !isRequestActive) {
          history.push("/expired");
        }
      }
    }
  }
}

export function* getSettings(action) {
  const { response, error } = yield call(
    apiPublic.action.getSettings,
    action.payload
  );
  if (response) {
    yield put({
      type: GET_SETTINGS_SUCCESS,
      payload: response.data.data
    });
  } else
    yield put({
      type: GET_SETTINGS_ERROR,
      payload: error
    });
}

export default function* AuthorizeSagas() {
  yield takeLatest(AUTHORIZE_LINK_VALIDATE_REQUEST, validateLink);
  yield takeLatest(AUTHORIZE_PAANS_CHECK_REQUEST, validatePaans);
  yield takeLatest(AUTHORIZE_PASSCODE_VALIDATE_REQUEST, validatePassCode);
  yield takeLatest(AUTHORIZE_LINK_ACTION_DATA_REQUEST, getActionData);
  yield takeLatest(AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST, getEnumActionTypes);
  yield takeLatest(AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST, expireOnTime);
  yield takeLatest(
    AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST,
    getEnumActionValidations
  );
  yield takeLatest(AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST, sendPassCode);
  yield takeLatest(
    AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST,
    isConfirmationCompleted
  );
  yield takeLatest(AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE, checkActiveRequest);
  yield takeLatest(GET_SETTINGS, getSettings);
}
